import { InputNumber, Slider, Space } from 'antd';
import PropTypes from 'prop-types';

// How the range is presented. The admin picks this per field, so a team that
// dislikes the horizontal slider can fall back to plain From/To boxes without
// any code change.
const RANGE_DISPLAYS = ['both', 'slider', 'inputs'];

// Value is always [from, to]. The slider and the number boxes are two views of
// that one tuple, so editing either updates the other.
export default function RangeSliderField({ field, value, onChange, disabled }) {
  const min = Number(field.min ?? 0);
  const max = Number(field.max ?? 30);
  const display = RANGE_DISPLAYS.includes(field.display) ? field.display : 'both';

  const current = Array.isArray(value) && value.length === 2 ? value : [undefined, undefined];
  const [from, to] = current;

  const emit = (next) => {
    const lo = next[0] === null || next[0] === undefined || next[0] === '' ? undefined : Number(next[0]);
    const hi = next[1] === null || next[1] === undefined || next[1] === '' ? undefined : Number(next[1]);
    if (lo === undefined && hi === undefined) {
      onChange(undefined);
      return;
    }
    // Dragging the low handle past the high one (or typing 10 then 2) would
    // otherwise send an inverted range the backend rejects.
    if (lo !== undefined && hi !== undefined) {
      onChange([Math.min(lo, hi), Math.max(lo, hi)]);
      return;
    }
    onChange([lo, hi]);
  };

  return (
    <div className="sbv1-range">
      {display !== 'inputs' && (
        <Slider
          range
          min={min}
          max={max}
          marks={field.marks}
          disabled={disabled}
          value={[from ?? min, to ?? max]}
          onChange={emit}
        />
      )}
      {display !== 'slider' && (
        <Space size={8} className="sbv1-range-inputs">
          <InputNumber
            size="small"
            min={min}
            max={max}
            disabled={disabled}
            value={from ?? null}
            placeholder={field.fromLabel ?? 'From'}
            onChange={(next) => emit([next, to])}
          />
          <span className="sbv1-range-dash">–</span>
          <InputNumber
            size="small"
            min={min}
            max={max}
            disabled={disabled}
            value={to ?? null}
            placeholder={field.toLabel ?? 'To'}
            onChange={(next) => emit([from, next])}
          />
        </Space>
      )}
    </div>
  );
}

RangeSliderField.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
